// extracted by mini-css-extract-plugin
export default {"socialNav":"socialNav_socialNav__edVhc","socialNavIcon":"socialNav_socialNavIcon__cTkvF"};